<template>
  <div>
    <TableFilters
      :filters="['status', 'customerType']"
      :columns="columns"
      v-model="filter"
      @updateColumnsTable="updateColumnsTable"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn @click="viewpdfFile()"> View Report </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="customer"
              item-key="id"
              class="row-pointer product-list"
              id="indextable12"
            >
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import axios from '@/plugins/axios';
import format from 'date-fns/esm/format';
import { mapState } from 'vuex';

export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.5%',
        render: (item) => item?.name,
      },
      {
        text: 'Type',
        value: 'type',
        show: true,
        align: 'left',
        disabled: false,
        width: '14.5%',
        render: (item) => item?.customerType.name,
      },

      {
        text: 'Due Amount',
        value: 'due_amount',
        show: true,
        align: 'right',
        disabled: false,
        width: '14.5%',
        render: (item) => item?.due_amount,
      },
      {
        text: 'Created at',
        value: 'created_at',
        show: true,
        disabled: false,
        align: 'left',
        width: '14.5%',
        render: (item) => moment(item.created_at).format('YYYY-MM-DD'),
      },
    ],
    customer: [],
    hide: '',
    // Filters
    filter: {
      name: '',
      customer: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;

      axios
        .get(
          `reports/customers?customerType=${
            filter.customerType ? filter.customerType : ''
          }&&status=${filter.status ? filter.status : ''}`,
        )

        .then((res) => {
          let i = 1;
          this.customer = res.data.data;
          this.customer.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            callBack();

            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            this.$store.commit('UPDATE_PDF_DATAS', this.customer);
            this.$store.commit('UPDATE_PDF_TITLE', 'Customers');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        // if (this.customer.length >= 0) {

        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        // }
      }, 1000);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.customer);
        for (let x = 0; x < Data.length; x++) {
          Data[x].type = Data[x].customerType.name;
          Data[x].created_at = moment(Data[x].created_at, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          );
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica');
        doc.text('Customers Report', 15, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        const conditions = [
          { key: 'status', label: 'Status' },
          { key: 'customerTypequery', label: 'Customer Type' },
        ];
        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };
        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(condition.key, condition.label, value);
          if (text) {
            doc.text(text, 15, acc);
            return acc + 5; // Increment
          }
          return acc;
        }, 12); // Initial

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'address') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Customers.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable12');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-customer.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },

  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
